package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class SchoolUpdateRequest(
    @SerialName("name")
    val name: String? = null,
    @SerialName("board")
    val board: String? = null,
    @SerialName("school_type")
    val schoolType: String? = null,
    @SerialName("medium")
    val medium: String? = null,
    @SerialName("address_line1")
    val addressLine1: String? = null,
    @SerialName("address_line2")
    val addressLine2: String? = null,
    @SerialName("city")
    val city: String? = null,
    @SerialName("district")
    val district: String? = null,
    @SerialName("state")
    val state: String? = null,
    @SerialName("country")
    val country: String? = null,
    @SerialName("pin_code")
    val pinCode: String? = null,
    @SerialName("school_phone")
    val schoolPhone: String? = null,
    @SerialName("school_email")
    val schoolEmail: String? = null,
    @SerialName("primary_contact_name")
    val primaryContactName: String? = null,
    @SerialName("primary_contact_phone")
    val primaryContactPhone: String? = null,
    @SerialName("primary_contact_email")
    val primaryContactEmail: String? = null,
    @SerialName("secondary_contact_name")
    val secondaryContactName: String? = null,
    @SerialName("secondary_contact_phone")
    val secondaryContactPhone: String? = null,
    @SerialName("secondary_contact_email")
    val secondaryContactEmail: String? = null,
    @SerialName("school_description")
    val schoolDescription: String? = null,
    @SerialName("attachment_file_ids")
    val attachmentFileIds: String? = null,
    @Transient
    val clearFields: Set<String> = emptySet()
)
